
<template>
    <nav class="nav" v-if="pages">
        <ul class="nav__list">
            <li
                v-for="({ name, order, path, children, status }) in navLinks"
                :class="['nav__item', { 'nav__item--parent' : children && children.length > 0 }]"
                :key="`${name}-${order}-${path}`"
                @mouseenter="handleParentEnter({ name, children })"
                @mouseleave="hoveredParent = null"
                @click="$emit('closeNav')"
            >
                <router-link
                    :to="path"
                    active-class="nav__link--active"
                    exact-active-class="nav__link--active-e"
                    :class="[
                        'nav__link',
                        { 'nav__link--active' : name == 'Common presentations' && $route.name === 'area' },
                        { 'nav__link--draft' : status === 'Draft' }
                    ]"
                ><span class="nav__status" v-if="status === 'Draft'">Draft</span>{{ name }}</router-link>

                <transition name="fade-in" mode="out-in">
                    <ul
                        :class="['nav__children', { 'nav__children--modal' : isModal }]"
                        v-if="hoveredParent === name || (isModal && children && children.length > 0)"
                    >
                        <li
                            v-for="({ name: cName, order: cOrder, path: cPath, status: cStatus }) in children"
                            class="nav__item nav__item--child"
                            :key="`${cName}-${cOrder}-${cPath}`"
                        >
                            <router-link
                                :to="cPath"
                                active-class="nav__link--active"
                                exact-active-class="nav__link--active-e"
                                :class="['nav__link', { 'nav__link--draft' : status === 'Draft' }]"
                            ><span class="nav__status" v-if="cStatus === 'Draft'">Draft</span>{{ cName }}</router-link>
                        </li>
                    </ul>
                </transition>
            </li>
            <li class="nav__item nav__item--logout">
                <a class="nav__link" href="#" @click.prevent="logoutUser">Logout</a>
            </li>
        </ul>

        <ul class="nav__list nav__list--admin" v-if="isAdmin">
            <li
                v-for="({ name, order, path }) in adminLinks"
                class="nav__item"
                :key="`${name}-${order}-${path}`"
                @click="$emit('closeNav')"
            >
                <router-link
                    :to="path"
                    active-class="nav__link--active"
                    exact-active-class="nav__link--active-e"
                    class="nav__link"
                >{{ name }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    props: {
        isModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hoveredParent: null,

            adminLinks: [
                { name: '+ Add New Resources', order: 0, path: '/admin/add-resources'},
                { name: '+ Add New Page', order: 10, path: '/admin/add-page'},
                { name: '+ Add New Article', order: 20, path: '/admin/add-article'},
                { name: 'Manage Login Content', order: 30, path: '/admin/edit-login'},
            ]
        }
    },

    computed: {
        ...mapGetters('Auth', ['isAdmin']),
        ...mapState('App', {
            pages: state => state.pages
                .filter(({ hideFromNav }) => !hideFromNav)
                .filter(({ hide_from_nav }) => {
                    // For some reason, the boolean is being passed as a string..?
                    return !hide_from_nav || hide_from_nav == 'false'
                })
        }),

        navLinks () {
            if (this.isAdmin) return this.sortLinks(this.pages)
            return this.sortLinks(this.pages).filter(({ status }) => status !== 'Draft')
        }
    },

    methods: {
        ...mapActions('Auth', ['logoutUser']),

        sortLinks (el) {
            const sorted = el
                .map(el => {
                    // the response gives back an "order" obj instead of "navOrder",
                    // so we make sure all elements have an "Order" key/value
                    if (!el.order && el.navOrder) el.order = el.navOrder
                    // then ensure there isn't a mix of strings and numbers
                    if (el.order > -1) el.order = Number(el.order)

                    return el
                })
                .sort((a, b) => a.order - b.order)

            return sorted
        },

        handleParentEnter ({ name, children }) {
            if (children && children.length > 0) { this.hoveredParent = name }
        }
    },
}
</script>

